__turbopack_context__.v({
  "container": "k03Msq_container",
  "content": "k03Msq_content",
  "cta-container": "k03Msq_cta-container",
  "root": "k03Msq_root" + " " + __turbopack_context__.i(905307)["sectionPadding"],
  "sentence": "k03Msq_sentence",
});
